import { Checkbox, Menu, MenuItem, OverflowText } from "designSystem/index";
import { POPOVER_BOTTOM_END } from "designSystem/styles/popover-positions";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { useBaseCompositionStore } from "./BaseCompositionStore";

interface BaseCompositionApplyToMenuProps {}

const BaseCompositionApplyToMenu: FunctionComponent<BaseCompositionApplyToMenuProps> = observer(function BaseCompositionMainPanel() {
	const {
		addApplyToCheckBox,
		applyToAnchorEl,
		applyToMenuOpen,
		applyToSalesRegionChecks,
		applyToSalesRegionNameDropdown,
		handleApplyToMenuClose,
		removeApplyToCheckBox,
	} = useBaseCompositionStore();

	return (
		<Menu
			anchorEl={applyToAnchorEl}
			aria-labelledby="sales-region-exception-button"
			id="sales-region-exception-menu"
			onClose={handleApplyToMenuClose}
			open={applyToMenuOpen}
			{...POPOVER_BOTTOM_END}
		>
			{applyToSalesRegionNameDropdown.map((srName: string, index: number) => {
				const onClickCheckBox = ((event): void => {
					event.stopPropagation();
					if (applyToSalesRegionChecks.has(srName)){
						removeApplyToCheckBox(srName);
					} else {
						addApplyToCheckBox(srName);
					}
				});
				return (
					<MenuItem 
						onClick={onClickCheckBox}
					>
						<Checkbox
							checked={applyToSalesRegionChecks.has(srName)}
							onChange={onClickCheckBox}
						/>
						<OverflowText text={srName} />
					</MenuItem>
				);
			})}
		</Menu>
	);});

export default BaseCompositionApplyToMenu;